/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1LocationCitiesId202,
  DeleteApiV1LocationCitiesId401,
  DeleteApiV1LocationCitiesId404,
  DeleteApiV1LocationCitiesId500,
  DeleteApiV1LocationCitiesIdMutationResponse,
  DeleteApiV1LocationCitiesIdPathParams,
} from "../../types/locationCityController/DeleteApiV1LocationCitiesId.ts";

export const deleteApiV1LocationCitiesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1LocationCitiesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1LocationCitiesId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCitiesId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1LocationCitiesId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCitiesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1LocationCitiesId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCitiesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1LocationCitiesId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1LocationCitiesId500>;

export const deleteApiV1LocationCitiesIdMutationResponseSchema = z.lazy(
  () => deleteApiV1LocationCitiesId202Schema,
) as unknown as ToZod<DeleteApiV1LocationCitiesIdMutationResponse>;
